import React from 'react';
import './Styles/Place.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
const Place=()=>{
    return(
        <div className="place-team">
            <h1>All your teams in one place</h1>
            <p>Make it easy to pull in relevant teams onto individual projects with our teams feature, simply group users into teams of your choice.</p>
            <p>This means it's effortless to identify and include the right people, when you need to, improving online design collaboration.</p>
            <div className="btns">
                <StyledButton btn="Create your team" styles="nobg-btn"/>
            </div>
            <div className="image-part"></div>
        </div>
    )
};
export default Place ;